import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {KnockoutPageComponent} from "./knockout-page.component";
import {LegacyRoutingService} from "../../core/services/legacy-routing/legacy-routing.service";

/**
 * This guard is to detect when a Knockout form has been modified and you want to change the route (i.e. using the
 * Back table operation). It uses the existing sammy function to do that.
 */
@Injectable()
export class ConfirmKnockoutDeactivateGuard implements CanDeactivate<KnockoutPageComponent> {

  private sammyRoutes: any;

  constructor(private legacyRoutingService: LegacyRoutingService) {
    this.sammyRoutes = legacyRoutingService.get();
  }

  canDeactivate(target: KnockoutPageComponent) {
    if (this.sammyRoutes && this.sammyRoutes.wildcardBeforeFunction) {
      // This sammy method uses app from the context Not sure how to set it.
      const context = {};
      return this.sammyRoutes.wildcardBeforeFunction(context);
    } else {
      return true;
    }
  }
}
